module.exports = __webpack_public_path__ + "img/request.7538f04e.svg";